import React, { useState } from 'react'
import {
  Button,
  Box,
  Modal,
  Typography,
  IconButton,
  Avatar,
  Grid,
  Tooltip,
} from '@mui/material'
import { CloseOutlined, Image } from '@mui/icons-material'
import moment from 'moment'
import { formatTime } from '../../lib/time'

const ViewWorkerModel = (props: any) => {
  var { data, dOpen } = props
  const [open, setOpen] = useState(dOpen ? true : false)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  if (!data) return <div></div>
  return (
    <div>
      <Button
        onClick={handleOpen}
        sx={{
          padding: '1.5px 12px',
          textTransform: 'capitalize',
          borderRadius: 2,
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: '#F0845D',
            boxShadow: 'none',
          },
          minWidth: 0,
          fontSize: 13,
        }}
        variant='contained'
        color='primary'>
        View
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'>
        <Box sx={modalStyle}>
          <Box
            display='flex'
            justifyContent='space-between'
            alignItems='center'>
            <Typography id='simple-modal-title' variant='h5'>
              Time Card Details
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseOutlined />
            </IconButton>
          </Box>
          <br />
          <strong>Worker:</strong>
          <Box
            style={{
              padding: '10px 0',
              flexDirection: 'row',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'left',
            }}>
            <Avatar
              src={data?.user?.idPhoto}
              alt='foreman picture'
              sx={{ marginRight: 1, width: 35, height: 35 }}
            />
            <Typography>{data?.user?.fullName}</Typography>
          </Box>

          <strong>Foreman:</strong>
          <Tooltip
            title={
              data?.superintendents?.length > 0
                ? data.superintendents.map((s: any) => (
                    <Box
                      key={s.id}
                      style={{
                        flexDirection: 'row',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'left',
                      }}>
                      <Avatar
                        src={s?.idPhoto ?? s?.picture}
                        alt='foreman picture'
                        sx={{ marginRight: 1, width: 35, height: 35 }}
                      />
                      {s?.firstName ?? '----'} {s?.lastName ?? '----'}
                    </Box>
                  ))
                : null
            }
            arrow>
            <Box
              style={{
                flexDirection: 'row',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'left',
              }}>
              <Avatar
                src={
                  data?.superintendents[0]?.idPhoto
                    ? data?.superintendents[0]?.idPhoto
                    : data?.superintendents[0]?.picture
                }
                alt='foreman picture'
                sx={{ marginRight: 1, width: 35, height: 35 }}
              />
              <Typography>
                {data?.superintendents[0]?.firstName ?? '----'}
                {data?.superintendents[0]?.lastName ?? '----'}
              </Typography>
            </Box>
          </Tooltip>
          <p>
            <strong>Project:</strong> {data?.project?.projectName}
            {/* {data?.project?.projectNumber}) */}
          </p>
            <p>
              <strong>Date:</strong>{' '}
              {data?.endTimeStamp 
                ? (moment(data?.startTimeStamp).isSame(data?.endTimeStamp, 'day')
                    ? moment(data?.startTimeStamp).format('MMMM Do YYYY')
                    : `${moment(data?.startTimeStamp).format('MMMM Do YYYY')} to ${moment(data?.endTimeStamp).format('MMMM Do YYYY')}`)
                : `${moment(data?.startTimeStamp).format('MMMM Do YYYY')} to Open`}
            </p>
          <p>
            <strong>Start Time:</strong>{' '}
            {data?.formattedTimeDurations?.startTime
              ? formatTime(data?.formattedTimeDurations?.startTime)
              : '---'}
          </p>
          <p>
            <strong>End Time:</strong>{' '}
            {data?.formattedTimeDurations?.endTime
              ? formatTime(data?.formattedTimeDurations?.endTime)
              : 'Open'}
          </p>
          <p>
            <strong>Total Time Worked:</strong>{' '}
            {data?.formattedTimeDurations?.totalTimeWorked}
          </p>
          <p>
            <strong>Regular Time Worked:</strong>{' '}
            {data?.formattedTimeDurations?.regularTimeWorked}
          </p>
          <p>
            <strong>Over Time Worked:</strong>{' '}
            {data?.formattedTimeDurations?.overTimeWorked}
          </p>
          <p>
            <strong>Double Over Time Worked:</strong>{' '}
            {data?.formattedTimeDurations?.doubleOverTimeWorked}
          </p>
        </Box>
      </Modal>
    </div>
  )
}

export default ViewWorkerModel

// Styling for the modal
const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  borderRadius: 3,
  boxShadow: 24,
  p: 4,
  outline: 'none',
}
